import * as React from 'react';
import LiquidacionDetalleTabla from './LiquidacionDetalleTabla';

const TABLE_HEAD = (
    <tr>
        <th scope="col">#</th>
        <th scope="col">Orden Ref</th>
        <th scope="col">Tipo</th>
        <th scope="col">Fecha</th>
        <th scope="col">Importe</th>
        <th scope="col">Acción</th>
    </tr>
);

export default class NovedadesDeLiquidacion extends React.Component {
    render = () => {
        const novedades = this.props.novedades ?? [];

        return (
            <LiquidacionDetalleTabla
                title="Novedades"
                data={novedades}
                isLoading={this.props.isLoading}
                loadingMessage="Cargando novedades de la liquidacion..."
                emptyMessage="No hay novedades para esta liquidación"
                tableHead={TABLE_HEAD}
                renderRow={(novedad, i, globalIndex) => (
                    <tr key={novedad.idNovedad ?? globalIndex} className="hover-background-color">
                        <td>{globalIndex + 1}</td>
                        <td>{novedad.ordenDeReferencia}</td>
                        <td>{novedad.tipoNovedadDescripcion}</td>
                        <td>{novedad.fechaNovedadMostrar}</td>
                        <td>{novedad.importeNovedad}</td>
                        <td>{novedad.descripcionSubTipoNovedad}</td>
                    </tr>
                )}
            />
        );
    };
}
